import { useEffect } from 'react'

import { shallowEqual, useSelector } from 'react-redux'

import BrandFansFilters from '@components/BrandFans/Filters/Filters'
import CampaignFilters from '@components/Campaign/Filters/Filters'
import ContentLibraryFilters from '@components/ContentLibrary/Filters/Filters'
import SideBar from '@components/UI/SideBar'
import { IApplicationState } from '@store'
import {
  selectBrandFanGroupsLink,
  selectContentLibraryEnabled,
  selectInfluencerIdentitiesLink,
} from '@store/me'

export const HomeSideBar: React.FC = () => {
  const { showContentLibrary, hasInfluencerIdentitiesLink, hasBrandFanGroupsLink } = useSelector(
    (state: IApplicationState) => ({
      showContentLibrary: selectContentLibraryEnabled(state),
      hasInfluencerIdentitiesLink: Boolean(selectInfluencerIdentitiesLink(state)),
      hasBrandFanGroupsLink: Boolean(selectBrandFanGroupsLink(state)),
    }),
    shallowEqual,
  )
  const showBrandFans = hasInfluencerIdentitiesLink || hasBrandFanGroupsLink

  // withScrollToTop functionality
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <SideBar>
      <CampaignFilters />
      {showContentLibrary && <ContentLibraryFilters />}
      {showBrandFans && <BrandFansFilters />}
    </SideBar>
  )
}

export default HomeSideBar
